/**
 * helixintegrationaction.js
 **/

import * as types from '../actiontypes';
import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';
import {API_RESOURCES, createApiReadAction} from '../../util/api';

export const GetHelixProjectFromCanvas = (engagementId, queryString, includeArray) =>
	createApiReadAction(
		types.GET_AVAILABLE_PROJECT_FROM_CANAVS_ENGAGEMENT,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TRIAL_BALANCE]: null
		},
		queryString,
		{
			resolve: true,
			includeArray
		}
	);

export const updateHelixProject = (engagementId, projectId, data) => {
	const url = env.getBaseURL(serviceURL, engagementId) + 'HelixProjects' + '/' + projectId;
	return {
		type: types.UPDATE_HELIX_PROJECT,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: data
			}
		},
		projectId,
		data
	};
};

export const importHelixProject = (engagementId, projectId, userDetail) => {
	const url = env.getBaseURL(serviceURL, engagementId) + 'HelixProjects' + '/imports';
	return {
		type: types.IMPORT_HELIX_PROJECT,
		meta: {
			api: {
				url,
				method: 'POST',
				data: {
					projectId: projectId
				}
			}
		},
		projectId: projectId,
		userDetail: userDetail
	};
};

export const cleanUpEngagementHelixProjectState = () => {
	return {
		type: types.CLEANUP_ENGAGEMENT_HELIX_PROJECTS_STATE
	};
};

export const deletePreviousHelixProjectImport = (engagementId, projectId) => {
	const url = env.getBaseURL(serviceURL, engagementId) + 'HelixProjects/' + projectId + '/Imports';
	return {
		type: types.DELETE_IMPORT_HELIX_PROJECT,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		},
		projectId: projectId
	};
};
